import type { BigSource } from 'big.js';
import type { ReactNode } from 'react';
import type { DefaultTheme } from 'styled-components';
import type { IconName } from '../Icons';

export enum NumberVariants {
  Positive = 'positive',
  Negative = 'negative',
  Warning = 'warning',
  Primary = 'primary',
  Muted = 'muted',
}

export type InlineFormattedNumberProps = {
  number?: BigSource;
  /** Set the increment to be used for display. If left undefined, will default to currency.DefaultIncrement. If set to null, will leave increment unset. */
  increment?: string | null;
  specification?: string;
  isSmall?: boolean;
  startIcon?: IconName;
  largeHighlight?: boolean;
  highlightAll?: boolean;
  currency?: string | null;
  background?: string;
  align?: 'left' | 'right' | 'center';
  variant?: NumberVariants;
  truncate?: boolean;
  round?: boolean;
  pretty?: boolean;
  estimate?: boolean;
  theme?: DefaultTheme;
  highlightColor?: string;
  showSign?: boolean;
  prefix?: ReactNode;
  /** When SmartTruncateEnum.Compact is used, decimals after 5dps will be truncated with "*"" */
  smartTruncate?: SmartTruncateEnum;
  smartTruncateThreshold?: BigSource;
  /** Whether or not to trim any trailing zeroes */
  trimTrailingZeroes?: boolean;
  /** If the number is equal to an empty string, show a dash instead*/
  showDashIfEmpty?: boolean;
  /** When true, render nothing when the value parses to exactly zero (Big.js eq). */
  omitZero?: boolean;
};

export enum SmartTruncateEnum {
  None = 'None',
  Compact = 'Compact',
}
